export default "__VITE_ASSET__CbR1$8sp__"